// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2oVgf","itemTitle":"ClientEmergencyInfo_itemTitle__3VXjp","itemText":"ClientEmergencyInfo_itemText__3CSHd"};